export default __webpack_public_path__ + "static/media/assiduo.bd6a4e6c.png";